import { useState, useEffect, useRef, Fragment } from "react";
import Config from "../../Config";
import back from "../../back.png";
import InputText from "../../helpers/InputText";
import FormatDecimal from "../../helpers/FormatDecimal";
import AppContext from "../../AppContext";
import InputCombo from "../../helpers/InputCombo";
import InputDecimal from "../../helpers/InputDecimal";
import InputLegend from "../../helpers/InputLegend";


function PricelistDetails(props)
{
    const [refreshView, setRefreshView] = useState(props.userData.refreshView);



  const [filterParam, setFilterParam] = useState({    
        bill_grupy_cennikowe_id:  '_x_',   
        fraza:  props.mainView.readFilter('fraza',''),   
      
        sortBy: {
            sort:  "", //asc desc,
            column: "",
        },

        limit: 50,
        page: 1,
        pages: 1,
        show: true,
    });


    const [errTab, setErrTab] = useState([]); 
    const [row, setRow] = useState(null);
    var tmpRow = row;


        const [legend, setLegend] = useState([
        
         {
            cls:'color_show4',
            title: 'prefix nie występuje w tym cenniku',
            filter: {  filed: "domyslny", set: "TAK", typ: "combo"  },
        },
    ]);


    const valChangeListenerF = (filedName, val, correct, msg) => {

            //console.log("valChangeListener: " + filedName + " " + val + ", correct: " + correct + ", msg: " + msg);
            setFilterParam( {...filterParam, [filedName]:val,  [filedName+"_valid"]:correct } );                                  
            if(   (val.length == 0 || val.length > 2 || msg =='combo')  && filterParam[filedName] != val )
            {
                    var defTimeOut = 500;
                    if(msg == 'combo') defTimeOut = 10;
                    clearTimeout(AppContext.timeoutId);
                    AppContext.timeoutId = setTimeout( () => {
                      //  setRow(null); 
                    } , defTimeOut );
            }
        
            props.mainView.writeFilter(filedName, val);    
            
            goUnselect();
        }

 

    const valChangeListener = (filedName, val, correct, msg) => {                         
                        
                tmpRow[filedName] = val;
                tmpRow[filedName+"_valid"] = correct;             
                setRow(  JSON.parse(JSON.stringify(tmpRow)) );                             
                //setRowX( {...row, [filedName]:val,  [filedName+"_valid"]:correct } );                        

                goUnselect();
            }   


 const [nParam0, setNParam0] = useState('0');  

      const paramListener0 = (filedName, val, correct, msg) => { 
               setNParam0(val);

               //aktualizuj ceny...
               if(row.prefixy != undefined)
                    {
                        for(var pp=0; pp< row.prefixy.length; pp++)
                        {
                            if(  val == '0' &&  row.prefixy[pp].selected == '1') row.prefixy[pp].cena = parseFloat(nParam);
                            if(  val == '1' &&  row.prefixy[pp].selected == '1') row.prefixy[pp].cena =  parseFloat(row.prefixy[pp].cena_org ) +  parseFloat(nParam) ; //zwieksz..
                            if(  val == '2' &&  row.prefixy[pp].selected == '1') row.prefixy[pp].cena =  parseFloat(row.prefixy[pp].cena_org ) -  parseFloat(nParam) ; //zmniejsz..
                        }

                        setRow( JSON.parse(JSON.stringify(row)) );
                    }


      }


   const [nParam, setNParam] = useState('');  

      const paramListener = (filedName, val, correct, msg) => { 
               setNParam(val);

               //aktualizuj ceny...
               if(row.prefixy != undefined)
                    {
                         for(var pp=0; pp< row.prefixy.length; pp++)
                        {
                            if(  nParam0 == '0' &&  row.prefixy[pp].selected == '1') row.prefixy[pp].cena = val;
                            if(  nParam0 == '1' &&  row.prefixy[pp].selected == '1') row.prefixy[pp].cena =  parseFloat(row.prefixy[pp].cena_org ) +  parseFloat( val ) ; //zwieksz..
                            if(  nParam0 == '2' &&  row.prefixy[pp].selected == '1') row.prefixy[pp].cena =  parseFloat(row.prefixy[pp].cena_org ) -  parseFloat( val ) ; //zmniejsz..
                        }
                        console.log("NN", nParam0, val);
                        setRow( JSON.parse(JSON.stringify(row)) );
                    }


      }


    const [view, setView] = useState ( "list");

          const changeView = (e ) => {
            var v = e.target.getAttribute('v');
            var id = e.target.getAttribute('id');

            setView({...view, ["v"]:v, ["id"]:id });
    }



    const goNextNew = () => 
        {
                console.log("goNext");               
        }


     const valChecker = (fields) => {

        var allValid = true;

              
        console.log(JSON.stringify(fields) );

        Object.entries(fields).forEach(function(entry) {

            var xKey    = entry[0];
            var xValue  = entry[1];                    

            var xValidName = xKey + "_valid";

            if(fields[xValidName] == false)
            {
                allValid = false;
                console.log("Error field: " + xKey);
            }
            
          });
        
          return allValid;

    }
    
    const getDet = () => {
        

        props.mainView.showProgress();       
 

        fetch( Config.url + '/rest_v1_info,pricelist_det', {
            method: 'POST', 
            body: JSON.stringify({id: props.id}), 
            headers: {
                'Content-Type': 'application/json',                    
                'X-Api-Key': props.userData.apiKey,
                '_fak_sprzedawcy_id_': props.userData.fak_sprzedawcy_id,   
                '_sec_key_': Config.genXKey() ,
            }
         })
         .then(res => res.json() )
         .then(res => { 

                props.mainView.hideProgress();    

                    if(res._sys_ == undefined)
                    {
                        props.mainView.showDialog( "Ups!", "No correct response from server" , "error" , null);  
                    }else
                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                    {
                        props.mainView.showDialog( "Ups!", JSON.stringify(res.result) , "error" , null);  
                    }else    
                    {
                        setRow(res.result);                                             
                    }
         } )
         .catch(err => {          
                    props.mainView.showDialog( "Ups!", "I: " + err , "error" , null);
                   props.mainView.hideProgress();    
         });
                   

         return false;
    }



     const saveData = () => {
        

        if(!valChecker(row))
        {
               
                props.mainView.showDialog("Ups!" , "Wypełnij prawidłowo pola formularza  " ,  "error"  ,null); 
                return;
        }

        props.mainView.showProgress();
 

        fetch( Config.url + '/rest_v1_info,pricelist_update', {
            method: 'POST', 
            body: JSON.stringify(row), 
            headers: {
                'Content-Type': 'application/json',                    
                'X-Api-Key': props.userData.apiKey,
                '_fak_sprzedawcy_id_': props.userData.fak_sprzedawcy_id,   
                '_sec_key_': Config.genXKey() ,
            }
         })
         .then(res => res.json() )
         .then(res => { 

                
                    props.mainView.hideProgress();

                    if(res._sys_ == undefined)
                    {
                        props.mainView.showDialog( "Ups!", "No correct response from server" , "error" , null);  
                    }else
                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                    {
                        props.mainView.showDialog( "Ups!", JSON.stringify(res.result) , "error" , null);  
                    }else    
                    {
                         props.mainView.showDialog( "Sukces",  "Dane zostały zapisane.", "ok" , (pp)=>{
                                props.onSuccess(res.result);  //przekaz id Firmy 
                         } );                                                  
                                                      
                    }
         } )
         .catch(err => {          
                    props.mainView.showDialog( "Ups!", "I: " + err , "error" , null);
                    props.mainView.hideProgress();
         });
                   

         return false;
    }


    const goUpdatePrice = () => {

            props.mainView.showDialog( "Potwierdź", "Czy na pewno chcesz zaktualizować wybrane ceny?" , "yesno" ,  (res)=>{
                
                    if(res == "yes")
                    {
                            setView({...view, ["v"]:"list", ["id"]:-1 });        

                                //----------------------  
                        

                                     props.mainView.showProgress();
 

                                                fetch( Config.url + '/rest_v1_info,pricelist_update', {
                                                    method: 'POST', 
                                                    body: JSON.stringify(row), 
                                                    headers: {
                                                        'Content-Type': 'application/json',                    
                                                        'X-Api-Key': props.userData.apiKey,
                                                        '_fak_sprzedawcy_id_': props.userData.fak_sprzedawcy_id,   
                                                        '_sec_key_': Config.genXKey() ,
                                                    }
                                                })
                                                .then(res => res.json() )
                                                .then(res => { 

                            
                                                            props.mainView.hideProgress();

                                                            if(res._sys_ == undefined)
                                                            {
                                                                props.mainView.showDialog( "Ups!", "No correct response from server" , "error" , null);  
                                                            }else
                                                            if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                                                            {
                                                                props.mainView.showDialog( "Ups!", JSON.stringify(res.result) , "error" , null);  
                                                            }else    
                                                            {
                                                                props.mainView.showDialog( "Sukces",  "Dane zostały zapisane.", "ok" , (pp)=>{
                                                                        props.onSuccess(res.result);  //przekaz id Firmy 
                                                                } );                                                  
                                                                                            
                                                            }
                                                } )
                                                .catch(err => {          
                                                            props.mainView.showDialog( "Ups!", "I: " + err , "error" , null);
                                                            props.mainView.hideProgress();
                                                });
                

                                //----------------------  

                    }

            })
    }

    //-------------------------------------------------------
//-------------------------------------------------------
//MASS
const changeSelected = (e) => {

    var id    = e.target.getAttribute('atr-id');   
    var selected = '0';

    if(e.target.checked) selected = '1';

    console.log("x", selected, id);

    var tmp = JSON.parse(JSON.stringify(row));

    for(var k=0; k<row.prefixy.length; k++)
    {
        if(tmp.prefixy[k].bill_cenniki_poz_id == id)  tmp.prefixy[k].selected = selected;
    }

    setRow( tmp);    
}

const changeSelectedAll = (e) => {

     var tmp = JSON.parse(JSON.stringify(row));

     var selected = tmp.prefixy[0].selected;

     if(selected == '1') { selected = '0'; } else selected = '1';

        for(var k=0; k<row.prefixy.length; k++)
        { 
                if( filterParam.bill_grupy_cennikowe_id != '_x_' &&  tmp.prefixy[k].bill_grupy_cennikowe_id != filterParam.bill_grupy_cennikowe_id) continue;

                var fraza = true;

                if(filterParam.fraza.length >2 )
                {
                            fraza = false;
                            if( tmp.prefixy[k].prefix.includes(filterParam.fraza)) fraza = true;
                }

                if(fraza == false) continue;


                tmp.prefixy[k].selected = selected;
        }

    setRow( tmp); 
}


const goUnselect = (e) => {
     
     var tmp = JSON.parse(JSON.stringify(row));

     if( tmp.prefixy == undefined) return;
 
        for(var k=0; k<row.prefixy.length; k++)
        {
              tmp.prefixy[k].selected = '0';
        }

    setRow( tmp); 
}

//-------------------------------------------------------
//-------------------------------------------------------


    



    
        const keyListener = (e) => { 
                                var code = e.keyCode ? e.keyCode : e.which;    
                                console.log("keylockdx", e.target.nodeName, code );

                                if( view.v == "new" && code == 27 )                                                  
                                {
                                     setView({...view, ["v"]:"list", ["id"]:-1 });
                                }else 
                                if(view.v == "new"  && code == 13 )                                                  
                                {
                                    goUpdatePrice();
                                }else 
                                if(e.target.nodeName.toLowerCase() != "body" && code == 27 )                                                  
                                {
                                    e.target.blur();
                                }else 
                                if(e.target.nodeName.toLowerCase() == "body" && code == 27 )                                                  
                                {                                                                
                                } else
                                if(e.target.nodeName.toLowerCase() == "body" && code == 8 )                                                  
                                {
                                        props.onBack();                               
                                } else 
                                {
                                    props.keyListener(e);
                                }                              
            }


        useEffect(() => {
                                     
                        if(Config.env == "dev") console.log("PricelistDetails.js, listener on");
                        window.onkeydown = keyListener;

                        return () => {          
                            if(Config.env == "dev") console.log("PricelistDetails.js, listener off");      
                            window.onkeydown =  props.keyListener;
                        };
            });
        


    if(row == null)            
    {
        setRow([]);
        getDet();
        return <div>...</div>
    }

  
         
    var itemsG = new Array();

    itemsG.push( {v:'_x_', title: ' - - - '} );

    if(row.grupy_cennikowe != undefined)
    {
        for(var k=0; k < row.grupy_cennikowe.length; k++)
        {
            itemsG.push({
                v: row.grupy_cennikowe[k].id,
                title: row.grupy_cennikowe[k].nazwa_grupy,
            });
        }
    }


    var index = 0;
    var selectedItems = 0;

    if(row.prefixy != undefined)
    {
        for(var pp=0; pp< row.prefixy.length; pp++)
        {
            if(row.prefixy[pp].selected == '1') selectedItems++;
        }
    }



    var dialogX = null;
    if(view.v == "new")
    {
        dialogX =  <div className="dlg_window shadowx " >

                        <div className="dlg_title" >Zmiana ceny (wybrano {selectedItems})</div>
                        <div className="dlg_msg" >

                        <div className="form_filed_inline">
                                    <InputCombo items={ [   {v:0,title: 'Ustaw wartość:'},  {v:1,title: 'Zwiększ cenę o wartość:'}, ,  {v:2,title: 'Zmniejsz cenę o wartość:'}, ] } value={nParam0} valChange={paramListener0} goNext={null}   name={"nParam0"} placeholder={": "}  />
                                    <InputDecimal  value={nParam} err={null}  valChange={paramListener} goNext={null}   name={"nParam"} placeholder={"Cena: "} className=' w200 ' req='0' firstUp="0" />                         
                        </div>
                      
                            
                        </div>
                                <div className="dlg_btn">
                                    <div className="btn" onClick={changeView} v="list" id="-1" >zamknij [esc]</div>
                                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                    <div className="btn" atr-type="ok" onClick={goUpdatePrice}>aktualizuj [enter]</div>
                        </div>
        </div>
 
    }




    return <div className="view_content">
                    <img src={back} onClick={props.onSuccess} className="back_img" title="wstecz"/>
                    
                    <div className="location">Cennik / Szczegóły / {row.nazwa}</div>

                    <form className="eForm bg_center">
                            <br/>
                            <div className="form_tab">                                            
                                
                                            <div className="form_control">
                                                <div className="fieldName">Nazwa cennika</div>
                                                <InputText   userData={props.userData} value={row.nazwa} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="nazwa" placeholder={"Nazwa:"} className='  ' req='1' firstUp="0" />
                                            </div>
                            </div>


                            <div className="form_split"></div>

                            <div className="form_btn">
                                        <div className="btn" onClick={saveData}>zapisz zmiany [ctrl + s ]</div>
                                        &nbsp;&nbsp;
                                       <div className="btn" onClick={props.onBack}    > anuluj [back]</div>
                            </div>


                    </form>

                    <br/>

               
                    {
                        row.prefixy != undefined &&
                        <Fragment>


                                <div className="table_filter">
                                    
                                    
                                                        <div className="filter_controll">   
                                                                <label>Grupa cennikowa: </label>                             
                                                                <InputCombo items={itemsG}   userData={props.userData} value={filterParam.bill_grupy_cennikowe_id}   valChange={valChangeListenerF} goNext={goNextNew} name="bill_grupy_cennikowe_id" placeholder={"Fraza: "}   />
                                                        </div> 

                                                        <div className="filter_controll">   
                                                                <label>Fraza / prefix: </label>                             
                                                                <InputText   userData={props.userData} value={filterParam.fraza}   valChange={valChangeListenerF} goNext={goNextNew} name="fraza" placeholder={"Fraza: "}   />
                                                        </div> 
                                </div>

                            
                                {
                                    selectedItems > 0 &&
                                    <Fragment>
                                            <div className="table_mass"> 
                                                <div className="title_mass">Operacje masowe (zaznaczono: {selectedItems}) </div>
                                                &nbsp; 

                                                <div className="btn" onClick={changeView} v="new" id="-1"  > Aktualizuj zaznaczone</div>
                                                &nbsp;&nbsp;

                                            </div>
                                    </Fragment>
                                }
                               

                                <div className="table_widget">

                                       
                                        <InputLegend items={legend}  valChange={valChangeListener} />

                                </div>

                                <table className="table"  >
                                                    <thead>
                                                    <tr className="header">                                                                                               
                                                        <td className="td_left">LP</td>                                                                                                                                                                         
                                                        <td onClick={changeSelectedAll}>Z</td>                                                                                                                                                                         
                                                        <td>BillCennikiPozID</td>                                                                                                                                    
                                                        <td>Nazwa operatora</td>                                                                                                                                    
                                                        <td>Grupa cennikowa</td>                                                                                                                                    
                                                        <td>Prefix</td>                                                                                                                                    
                                                        <td>Opis</td>                                                                                                                                    
                                                        <td>Opis cd.</td>                                                                                                                                    
                                                        <td className="td_right">Cena</td>                                                                                      
                                                        <td className="td_option"></td>                                                                                  
                                                    </tr>
                                                </thead>

                                                {
                                                    row.prefixy.map( (pp, ix) => {

                                                            var rowStyle = " row ";
                                                            if(index % 2 == 0 )rowStyle = " row2 ";

                                                            

                                                            if( filterParam.bill_grupy_cennikowe_id != '_x_' && pp.bill_grupy_cennikowe_id != filterParam.bill_grupy_cennikowe_id) return null;

                                                            if( filterParam.bill_grupy_cennikowe_id != '_x_' &&   pp.bill_cenniki_poz_id <= 0 ) return null;

                                                            var fraza = true;

                                                            if(filterParam.fraza.length >2 )
                                                            {
                                                                fraza = false;
                                                                if(pp.prefix.includes(filterParam.fraza)) fraza = true;
                                                            }

                                                            if(fraza == false) return null;

                                                            index++;

                                                            var isChecked = false;
                                                            if(pp.selected == "1") isChecked = true;

                                                            if(pp.bill_cenniki_poz_id < 0 )
                                                            {
                                                                rowStyle = rowStyle =  " color_show4 ";
                                                            }


                                                  

                                                            return <tr className={rowStyle} >                                                                                               
                                                                <td className="gocenter">{index}</td>                                                                                                                                                                         

                                                                <td className="gocenter">
                                                                    <input type="checkbox" atr-id={pp.bill_cenniki_poz_id} onChange={changeSelected} checked={isChecked} />
                                                                </td>  

                                                                <td className="gocenter">
                                                                    {
                                                                       pp.bill_cenniki_poz_id > 0 &&
                                                                       <Fragment>
                                                                        {pp.bill_cenniki_poz_id}
                                                                       </Fragment>
                                                                    } {
                                                                       pp.bill_cenniki_poz_id <= 0 &&
                                                                       <Fragment>
                                                                         Brak ID  [{pp.bill_cenniki_poz_id}]
                                                                       </Fragment>
                                                                    }
                                                                </td>                                                                                                                                                                         
                                                                <td className="gocenter">{pp.nazwa_operatora}</td>    
                                                                <td className="gocenter">{pp.nazwa_grupy}</td>    
                                                                <td className="gocenter">{pp.prefix}</td>                                                                                                                                    
                                                                <td className="goleft">{pp.opis1}</td>                                                                                                                                    
                                                                <td className="goleft">{pp.opis2}</td>                                                                                                                                    
                                                                <td className="td_right goright"><FormatDecimal value={pp.cena} /></td>                                                                                      
                                                                <td className="td_option"></td>                                                                                  
                                                            </tr>

                                                    } )
                                                }

                                           </table>

                        </Fragment>
                    }

 
                  {dialogX}                       
 
 
    </div>
}



export default PricelistDetails;

